import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, ReactiveFormsModule} from '@angular/forms';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AppValidators, TranslatePipe} from '@brunata-angular/util';
import {InputTextGroupComponent} from '@brunata-angular/ui';

@Component({
    selector: 'app-edit-email-address-modal',
    templateUrl: './edit-email-address-modal.component.html',
    styleUrls: ['./edit-email-address-modal.component.scss'],
    imports: [TranslatePipe, ReactiveFormsModule, NgbModule, InputTextGroupComponent],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditEmailAddressModalComponent implements OnInit {
    @Input() email: string | undefined;
    formGroup = this.formBuilder.group({
        email: ['', AppValidators.email],
    });
    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder,
    ) {}

    submit(): void {
        this.formGroup.markAllAsTouched();
        if (this.formGroup.valid) {
            this.activeModal.close(this.formGroup.value.email);
        }
    }
    ngOnInit(): void {
        this.formGroup.controls.email.setValue(this.email ?? '');
    }
}
